define.alias("shared/components/shared/social/instagram-upgrade/modal", "settings/components/shared/social/instagram-upgrade/modal");